var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpsgenieIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 60.76 73.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#253858;}.cls-2{fill:url(#linear-gradient);}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:#2684ff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 30.03,
    y1: 6.57,
    x2: 30.03,
    y2: 43.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2684ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#0052cc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 19.05,
    y1: 42.17,
    x2: 31.32,
    y2: 67.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2684ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#0052cc"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Opsgenie-blue-rgb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 30.03,
    cy: 18.48,
    r: 17.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.51,71.7A86.06,86.06,0,0,1,.26,42.17a2,2,0,0,1,.87-2.77l13.51-6.63a2,2,0,0,1,2.61.8,66.79,66.79,0,0,0,29,26.25A86.5,86.5,0,0,1,31.55,71.7,2.87,2.87,0,0,1,28.51,71.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M31.55,71.7A86,86,0,0,0,59.8,42.17a2,2,0,0,0-.86-2.77L45.42,32.77a2,2,0,0,0-2.61.8,66.76,66.76,0,0,1-29,26.25A86,86,0,0,0,28.51,71.7,2.87,2.87,0,0,0,31.55,71.7Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpsgenieIcon);
export default __webpack_public_path__ + "static/media/opsgenie-icon.f62256176b9ea65ab622fbb5823c8aad.svg";
export { ForwardRef as ReactComponent };